<script lang="ts">
    import dayjs from "dayjs";

    import { useNavigate } from "svelte-navigator";
    import { DayOfWeek } from "../../../../../../admin-service-typescript-client";
    import { LocalDateTimeFormat } from "../../../../../settings/settings";
    export let onChangeCallback;

    let timeTable = [];

    const propagateChange = () => {
        timeTable = [];
        tableObjectsArray.forEach((weekdayObject) => {
            const indexes = [];
            const slotsArr = weekdayObject.slots;

            slotsArr.forEach((slot, index) => {
                if (slot === 1) {
                    indexes.push(index);
                }
            });

            timeTable = [
                ...timeTable,
                ...indexes.reduce(
                    (
                        parsedSlots: {
                            dayOfWeek: DayOfWeek;
                            from: string;
                            to: string;
                        }[],
                        item,
                        index,
                        array
                    ) => {
                        if (parsedSlots.length === 0)
                            return [
                                {
                                    dayOfWeek: weekdayObject.weekday,
                                    from: dayjs()
                                        .set("minute", 0)
                                        .set("second", 0)
                                        .set("ms", 0)
                                        .set("hour", item)
                                        .format(LocalDateTimeFormat),
                                    to: dayjs()
                                        .set("ms", 999)
                                        .set("second", 59)
                                        .set("minute", 59)
                                        .set("hour", item)
                                        .format(LocalDateTimeFormat),
                                },
                            ];
                        if (item - 1 === array[index - 1]) {
                            return [
                                ...parsedSlots.slice(0, -1),
                                {
                                    ...parsedSlots[parsedSlots.length - 1],
                                    to: dayjs()
                                        .set("ms", 999)
                                        .set("second", 59)
                                        .set("minute", 59)
                                        .set("hour", item)
                                        .format(LocalDateTimeFormat),
                                },
                            ];
                        }
                        return [
                            ...parsedSlots,
                            {
                                dayOfWeek: weekdayObject.weekday,
                                from: dayjs()
                                    .set("minute", 0)
                                    .set("second", 0)
                                    .set("ms", 0)
                                    .set("hour", item)
                                    .format(LocalDateTimeFormat),
                                to: dayjs()
                                    .set("ms", 999)
                                    .set("second", 59)
                                    .set("minute", 59)
                                    .set("hour", item)
                                    .format(LocalDateTimeFormat),
                            },
                        ];
                    },
                    []
                ),
            ];
        });

        onChangeCallback(timeTable);
    };

    const toggleSlot = (weekdayIndex: number, valueIndex: number) => {
        tableObjectsArray[weekdayIndex].slots[valueIndex] =
            tableObjectsArray[weekdayIndex].slots[valueIndex] === 0 ? 1 : 0;
        propagateChange();
    };

    let tableObjectsArray = [
        {
            key: "Montag",
            weekday: DayOfWeek.Monday,
            slots: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0,
            ],
        },
        {
            key: "Dienstag",
            weekday: DayOfWeek.Tuesday,
            slots: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0,
            ],
        },
        {
            key: "Mittwoch",
            weekday: DayOfWeek.Wednesday,
            slots: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0,
            ],
        },
        {
            key: "Donnerstag",
            weekday: DayOfWeek.Thursday,
            slots: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0,
            ],
        },
        {
            key: "Freitag",
            weekday: DayOfWeek.Friday,
            slots: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0,
            ],
        },
        {
            key: "Samstag",
            weekday: DayOfWeek.Saturday,
            slots: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0,
            ],
        },
        {
            key: "Sonntag",
            weekday: DayOfWeek.Sunday,
            slots: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0,
            ],
        },
    ];

    let isActive = false;
</script>

<table>
    <thead>
        <tr>
            <th />
            {#each tableObjectsArray[0].slots as row, index}
                <th
                    ><div
                        class="hover text-center"
                        on:click={() => {
                            if (
                                tableObjectsArray.reduce(
                                    (total, weekday) =>
                                        total + weekday.slots[index],
                                    0
                                ) > 0
                            ) {
                                tableObjectsArray.forEach(
                                    (weekday, weekdayIndex) =>
                                        (tableObjectsArray[weekdayIndex].slots[
                                            index
                                        ] = 0)
                                );
                                propagateChange();
                                return;
                            }
                            tableObjectsArray.forEach(
                                (weekday, weekdayIndex) =>
                                    (tableObjectsArray[weekdayIndex].slots[
                                        index
                                    ] = 1)
                            );
                            propagateChange();
                        }}
                    >
                        {index}
                    </div></th
                >
            {/each}
        </tr>
    </thead>
    <tbody>
        {#each tableObjectsArray as weekday, weekdayIndex}
            <tr
                on:mouseup={() => {
                    if (isActive) isActive = false;
                }}
                on:mousedown={() => (isActive = true)}
            >
                <td>
                    <div
                        class="hover "
                        on:click={() => {
                            if (
                                weekday.slots.reduce(
                                    (total, value) => total + value,
                                    0
                                ) > 0
                            ) {
                                tableObjectsArray[weekdayIndex].slots = [
                                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                                    0, 0, 0, 0, 0, 0, 0, 0, 0,
                                ];
                                propagateChange();
                                return;
                            }
                            tableObjectsArray[weekdayIndex].slots = [
                                1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
                                1, 1, 1, 1, 1, 1, 1, 1,
                            ];
                            propagateChange();
                        }}
                    >
                        {weekday.key}
                    </div>
                </td>
                {#each weekday.slots as value, valueIndex}
                    <td
                        style={"background-color: " +
                            (value === 0 ? "white;" : "#1D95AC;") +
                            " border-left: 1px solid #dbdbdb;"}
                        class="hover"
                        on:mouseenter={() => {
                            if (isActive) toggleSlot(weekdayIndex, valueIndex);
                        }}
                        on:mousedown={() => {
                            toggleSlot(weekdayIndex, valueIndex);
                        }}
                    />
                {/each}
            </tr>
        {/each}
    </tbody>
</table>

<style>
    .hover {
        cursor: pointer;
    }

    .text-center {
        text-align: center;
    }
</style>
